import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import JobListPage from "./pages/JobListPage";
import JobDetailPage from "./pages/JobDetailPage";
import ApplicationTestPage from "./pages/ApplicationTestPage";
import ThankYouPage from "./pages/ThankYouPage";

function App() {
  return (
    <Router>
      <Routes>
        {/* ===== Landing ===== */}
        <Route path="/" element={<LoginPage />} />

        {/* ===== Employer ===== */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/jobs" element={<JobListPage />} />
        <Route path="/jobs/:jobId" element={<JobDetailPage />} />

        {/* ===== Candidate ===== */}
        <Route path="/candidate" element={<ApplicationTestPage />} />
        <Route path="/candidate/:applicationCode" element={<ApplicationTestPage />} />

        {/* ===== Test (short & clean) ===== */}
        <Route path="/test/:applicationCode" element={<ApplicationTestPage />} />
        <Route path="/preview/:applicationCode" element={<ApplicationTestPage />} />

        {/* ===== Legacy (KEEP) ===== */}
        <Route
          path="/application-test/:mode/:applicationCode"
          element={<ApplicationTestPage />}
        />

        {/* ===== Thank you ===== */}
        <Route path="/thank-you" element={<ThankYouPage />} />

        {/* ===== Fallback ===== */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
